<template>
  <FinishedAuctionsCatalogsOrdersList />
</template>

<script>
  import FinishedAuctionsCatalogsOrdersList from './orders/list';

  export default {
    name: 'Orders',
    components: {
      FinishedAuctionsCatalogsOrdersList,
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/components/finished/orders.vue?6eac480c